module.exports = function isIframe() {
	if (typeof window !== "undefined") {
		try {
			return window.self !== window.top;
		} catch (e) {
			return true;
		}
	}
	return false;
};
